module.exports = __webpack_public_path__ + "img/Certificate_pic04.5557f70b.png";